import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    lpTag: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class LiveChatService {
  public registerChatBot$: Observable<string>;
  public showChatBot$: Observable<string>;
  private registerChatBotSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private showChatBotSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.registerChatBot$ = this.registerChatBotSubject.asObservable();
    this.showChatBot$ = this.showChatBotSubject.asObservable();
  }

  public registerChatBot(chatBotId: string) {
    this.registerChatBotSubject.next(chatBotId);
  }

  public showChatBot(chatBotId: string) {
    this.showChatBotSubject.next(chatBotId);
  }

  // this function is for live chat tiles which are not displayed on page load and are show dynamically later which could be behind a CTA button on the page.
  // in this scenario you need to call the following function to reload live person monitor to look for the live person div id to integrate chat.
  reloadLiveAgentMonitor() {
    if (isPlatformBrowser(this.platformId)) {
      window.lpTag?.newPage(window.location.href);
    }
  }

  public createChatContainer(renderer: Renderer2, chatBotId: string): HTMLDivElement {
    let chatContainerDiv = document.getElementById(chatBotId);

    if (chatContainerDiv) {
      return chatContainerDiv as HTMLDivElement;
    }

    chatContainerDiv = renderer.createElement('div');
    renderer.setAttribute(chatContainerDiv, 'id', chatBotId);
    renderer.setStyle(chatContainerDiv, 'display', 'none');
    renderer.appendChild(document.body, chatContainerDiv);

    return chatContainerDiv as HTMLDivElement;
  }
}
